import { colors } from './colors';

export const fontFamilies = {
  heading: 'Futura PT',
  body: 'Inter, Roboto, sans-serif',
} as const;

export const fontWeights = {
  regular: 400,
  medium: 500,
} as const;

const headingDefaults = {
  fontFamily: fontFamilies.heading,
  fontWeight: fontWeights.medium,
  color: colors.text.primary,
} as const;

const bodyDefaults = {
  fontFamily: fontFamilies.body,
  fontWeight: fontWeights.medium,
  color: colors.text.secondary,
} as const;

export const typeScale = {
  h1: {
    ...headingDefaults,
    fontSize: '4.5rem',
    lineHeight: 1.2,
  },
  h2: {
    ...headingDefaults,
    fontSize: '2.375rem',
    lineHeight: 1.2,
  },
  h3: {
    ...headingDefaults,
    fontSize: '2rem',
    lineHeight: 1.2,
  },
  h4: {
    ...headingDefaults,
    fontSize: '1.5rem',
    lineHeight: 1.55,
  },
  subtitle1: {
    ...bodyDefaults,
    fontSize: '1.125rem',
    lineHeight: 1.66,
  },
  subtitle2: {
    ...bodyDefaults,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  body1: {
    ...bodyDefaults,
    fontSize: '1.125rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.55,
  },
  body2: {
    ...bodyDefaults,
    fontSize: '1rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.5,
  },
  body3: {
    ...bodyDefaults,
    fontSize: '0.875rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.42,
  },
  body4: {
    ...bodyDefaults,
    fontSize: '0.75rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.66,
  },
  caption: {
    ...bodyDefaults,
    fontSize: '0.875rem',
    lineHeight: 1.42,
  },
  overline: {
    ...bodyDefaults,
    fontSize: '0.75rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.66,
  },
  button: {
    ...bodyDefaults,
    fontSize: '0.875rem',
    lineHeight: 1.33,
  },
  buttonSm: {
    ...bodyDefaults,
    fontSize: '0.875rem',
    lineHeight: 1.0,
  },
  buttonMd: {
    ...bodyDefaults,
    fontSize: '0.875rem',
    lineHeight: 1.0,
  },
  buttonLg: {
    ...bodyDefaults,
    fontSize: '1rem',
    lineHeight: 1.0,
  },
  inputSm: {
    ...bodyDefaults,
    fontSize: '0.875rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.14,
  },
  inputMd: {
    ...bodyDefaults,
    fontSize: '1rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.25,
  },
  inputLg: {
    ...bodyDefaults,
    fontSize: '1.125rem',
    fontWeight: fontWeights.regular,
    lineHeight: 1.33,
  },
  avatar: {
    ...bodyDefaults,
    fontSize: '0.875rem',
    lineHeight: 1.3,
  },
} as const;
